module.exports = __webpack_public_path__ + "img/camera.e8588a3c.svg";